<template>
  <loader v-if="processing"></loader>
</template>
<script>
import { ParticipantPortal, Widget } from "@/components/services/participant-service";
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import moment from "moment";
import loader from "@/components/common/loader";
export default {
  components: { loader },
  data() {
    return {
      portal: new ParticipantPortal(),
      widget: new Widget(),
      studyLatestVersionId: "",
      participantCurrent: 0,
      studyLatestVersion: 0,
      processing: false
    };
  },
  mounted() {
    this.getStudyDetails();
  },
  computed: {
    ...mapGetters(["participant"]),

    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    }
  },
  methods: {
    checkifSchedulesGenerated() {
      return new Promise((resolve, reject) => {
        const payload = {
          pid: this.participant.pid,
          studyId: this.portal.getStudy(),
          versionId: this.studyLatestVersionId
        };
        const intervalHandler = () => {
          this.$api
            .isTaskScheduleCreatedForNewStudyVersion(payload)
            .then(res => {
              const status = res.data.status;
              if (status === "INPROGRESS") {
                //Loader is showing globally, do nothing
                intervalHandler();
              } else if (status === "SUCCEEDED") {
                resolve(res);
              } else {
                reject("Internal Server Error");
              }
            })
            .catch(err => {
              reject(err);
            });
        };
        setTimeout(intervalHandler, 1000);
      });
    },
    showSwal() {
      swal({
        title: this.widget.translate("pweb_app_update_message", "A new version of the app is available and required to continue."),
        type: "",
        icon: false,
        iconHtml: "<p></p>",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        confirmButtonText: this.widget.translate("OK_BUTTON_TITLE", "OK"),
        confirmButtonColor: this.globalElements && this.globalElements.colorPrimary ? this.globalElements.colorPrimary : "#4B628B",
        preConfirm: async () => {
          this.processing = true;
          const payload = {
            participantLocalTime: moment().format(),
            participantLocalTimeOffset: moment().format("Z"),
            dayOnStudy: this.portal.getDayFromDate(),
            pid: this.participant.pid,
            studyId: this.portal.getStudy(),
            versionId: this.studyLatestVersionId
          };
          try {
            await this.$api.updateParticipantStudyVersion(payload);
            await this.$store.dispatch("checkifSchedulesGenerated", {
              pid: this.participant.pid,
              studyId: this.portal.getStudy(),
              versionId: this.studyLatestVersionId
            });
            return true;
          } catch (err) {
            const message = this.widget.translate(err, err);
            this.$toastr.error(message);
            this.processing = false;
            return false;
          }
        }
      }).then(() => {
        this.portal.updateUserDetails({
          myStudyVersionId: this.studyLatestVersionId,
          studyVersionId: this.studyLatestVersionId,
          studyVersionNumber: this.studyLatestVersion
        });
        this.processing = false;
        window.location.reload();
      });
    },
    getStudyDetails() {
      this.$api.getStudyDetail(this.portal.getStudy()).then(res => {
        this.participantCurrent = +this.participant.studyVersionNumber;
        this.studyLatestVersion = +res.data.data.studyVersion;
        this.studyLatestVersionId = res.data.data.studyVersionId;
        //If study has latest version than the participants current study version
        if (this.participantCurrent < this.studyLatestVersion) {
          this.showSwal();
        }
      });
    }
  }
};
</script>
